export default "__VITE_ASSET__LL5IYP0I__"